<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="6" lg="3">
      <FilterSearch :fetchData="fetchCustomers" inner-icon="mdi-magnify" />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('appointment.filters.subscriptionType')"
        :fetchData="fetchCustomers"
        :items="subscriptionTypes"
        type="subscriptionType"
        value="value"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <filter-autocomplete
        :label="$t('host.label.serviceProvider')"
        :fetch-data="fetchCustomers"
        :items="serviceProviderOptions"
        type="withServiceProvider"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="3">
      <FilterCity
        :fetchData="fetchCustomers"
        :multiple="true"
        type="cityIds"
      />
    </v-col>
  </v-row>
</template>

<script>
import FilterSearch from '@/components/filters/FilterSearch'
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'
import FilterCity from '@/components/filters/FilterCity'

import { mapActions } from 'vuex'

export default {
  name: 'CustomerListFilters',

  components: {
    FilterSearch,
    FilterAutocomplete,
    FilterCity,
  },

  data() {
    return {
      subscriptionTypes: [
        { name: this.$t('realEstate.subscriptionTypes.TRIAL'), value: 'TRIAL'},
        { name: this.$t('realEstate.subscriptionTypes.SINGLE_PURCHASE'), value: 'SINGLE_PURCHASE'},
        { name: this.$t('realEstate.subscriptionTypes.PREPAID'), value: 'PREPAID'},
        { name: this.$t('realEstate.subscriptionTypes.PREPAID_SAAS'), value: 'PREPAID_SAAS'},
        { name: this.$t('realEstate.subscriptionTypes.POSTPAID'), value: 'POSTPAID'},
        { name: this.$t('realEstate.subscriptionTypes.POSTPAID_SAAS'), value: 'POSTPAID_SAAS'},
        { name: this.$t('realEstate.subscriptionTypes.SUBSCRIPTION_TRIMESTER'), value: 'SUBSCRIPTION_TRIMESTER'},
        { name: this.$t('realEstate.subscriptionTypes.SUBSCRIPTION_SEMESTER'), value: 'SUBSCRIPTION_SEMESTER'},
        { name: this.$t('realEstate.subscriptionTypes.SUBSCRIPTION_NONAMESTER'), value: 'SUBSCRIPTION_NONAMESTER'},
        { name: this.$t('realEstate.subscriptionTypes.SUBSCRIPTION_YEAR'), value: 'SUBSCRIPTION_YEAR'},
        { name: this.$t('realEstate.subscriptionTypes.SUBSCRIPTION_LIFELONG'), value: 'SUBSCRIPTION_LIFELONG'}
      ],
        serviceProviderOptions: [
          { name: this.$t('filters.yes'), value: true },
          { name: this.$t('filters.no'), value: false },
      ],
    }
  },

  methods: {
    ...mapActions(['fetchCustomers']),
  },
}
</script>
